import { takeLatest, call, all, put, select } from 'redux-saga/effects'
import { userContextApi } from '@edulastic/api'
import _ from 'lodash'
import * as Sentry from '@sentry/browser'
import {
  GET_VIEWED_TUTORIALS_FAILURE,
  GET_VIEWED_TUTORIALS_REQUEST,
  GET_VIEWED_TUTORIALS_SUCCESS,
  SET_VIEWED_TUTORIALS_FAILURE,
  SET_VIEWED_TUTORIALS_REQUEST,
  SET_VIEWED_TUTORIALS_SUCCESS,
} from './tutorialReducer'

function* getViewedTutorials() {
  try {
    const viewedTutorials = yield call(userContextApi.getViewedTutorials)
    yield put({
      type: GET_VIEWED_TUTORIALS_SUCCESS,
      payload: viewedTutorials?.value ?? [],
    })
  } catch (err) {
    Sentry.captureException(err)
    yield put({
      type: GET_VIEWED_TUTORIALS_FAILURE,
      payload: err,
    })
  }
}

function* setViewedTutorials({ payload }) {
  try {
    const current = yield select((state) => state.tutorial.viewedTutorials)
    const incoming = Array.isArray(payload) ? payload : [payload]
    const merged = _.uniq([...current, ...incoming])
    yield call(userContextApi.storeViewedTutorials, merged)
    yield put({
      type: SET_VIEWED_TUTORIALS_SUCCESS,
      payload: merged,
    })
  } catch (err) {
    Sentry.captureException(err)
    yield put({
      type: SET_VIEWED_TUTORIALS_FAILURE,
      payload: err,
    })
  }
}

export function* watcherSaga() {
  yield all([
    takeLatest(GET_VIEWED_TUTORIALS_REQUEST, getViewedTutorials),
    takeLatest(SET_VIEWED_TUTORIALS_REQUEST, setViewedTutorials),
  ])
}
